<template>
  <section class="container-sarah">
    <div class="align columns is-vcentered">
      <div class="colum img view-desktop">
        <img
          class="login-section_logo"
          src="~@/assets/images/banners/documents-sarah_FormServicos.svg"
          alt="Doutores"
        />
      </div>
      <div class="column text">
        <h3>{{ $t('documentos.outros-servicos.subtitulo') }}</h3>

        <p>
          {{ $t('documentos.outros-servicos.descricao') }}
        </p>
      </div>
    </div>
    <!-- table of content -->
    <tablelist
      class="table"
      :data="getOutrosServicos"
      :columns="columnsList"
      :isnt-checkable="true"
      :filter-data="true"
      @filter-date="setFilter"
    />
  </section>
</template>

<script>
import TableList from '@/components/shared/table/TableList'
import { mapGetters, mapActions } from 'vuex'
import { TiposDocumentos } from '../../mixins/tipos-documentos'
import { NotAuthenticatedError } from '../../models/not-authenticated-error'
import { format } from 'date-fns'

export default {
  name: 'DocumentosServicos',
  components: { tablelist: TableList },
  data () {
    return {
      columnsList: [
        {
          field: 'date',
          label: 'Data'
        },
        {
          field: 'description',
          label: 'Descrição'
        },
        {
          field: 'id',
          label: 'Action'
        }
      ]
    }
  },
  created () {
    this.setFilter()
  },
  computed: {
    ...mapGetters({
      getDates: 'getDateFilter',
      getOutrosServicos: 'getOutrosServicos'
    })
  },
  methods: {
    ...mapActions(['obterOutrosServicos']),
    redirectToChat () {
      window.open('http://www.sarah.br/chat')
    },
    setFilter () {
      let payload = {
        type: TiposDocumentos.CopiaProntuario,
        initDate: this.getDates.initDate,
        endDate: this.getDates.endDate
      }
      if (!payload.initDate) {
        payload.initDate = format(new Date(0), 'dd/MM/yyyy')
      }
      if (!payload.endDate) {
        payload.endDate = format(new Date(), 'dd/MM/yyyy')
      }
      this.obterOutrosServicos({ ...payload }).catch((err) => {
        if (err instanceof NotAuthenticatedError) this.$router.push('/')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/stylesheets/base";
@import "~@/assets/stylesheets/document";

@media (max-width: 64rem) {
  .align {
    margin-top: 3rem;

    .img {
      margin: 0;
      display: flex;
      justify-content: center;
    }

    .text {
      padding: 0;
      margin-top: 1.5rem;
    }
  }
}

@media (min-width: 64rem) {
  .align {
    padding-left: 10%;
    padding-right: 10%;
  }
}
</style>
